import { ColorManager } from "../../lib/layers/selectable/color";
import { BufferLayer } from "../layers/client/BufferLayer";
import { GroupLayer, MarkerLayer, MeasureLayer, ZoomboxLayer } from "../layers/client/ClientLayers";
import { CurrentLocationLayer } from "../layers/client/CurrentLocationLayer";
import { SketchLayer } from "../layers/client/SketchLayer";
import { InspectionsLayer } from "../layers/selectable/InspectionsLayer";
import { ParcelLayer } from "../layers/selectable/ParcelLayer";
import { SalesRatioLayer } from "../layers/selectable/SalesRatioLayer";
import { KellyStrategy, LinearStrategy, RadialStrategy, SingleColorStrategy } from "../layers/selectable/strategies";
import { ColorizedParcelStyle, DefaultParcelStyle } from "../layers/selectable/styles";
const init_select = (view, config, map) => {
    const color_manager = new ColorManager({
        strategies: [new KellyStrategy(), new SingleColorStrategy(), new LinearStrategy(), new RadialStrategy()],
        color_range: {
            start_color: '#FF0000',
            end_color: '#0000FF',
            num_colors: 5,
            opacity: 100
        }
    });
    const layer_options = {
        url: config.ParcelQueryUrl,
        parcel_query_urls: config.ParcelQueryUrls,
        identifier: config.ParcelIdentifierColumn,
        authRequired: config.authRequired,
        authUser: config.authUser,
        authPassword: config.authPassword,
        color_manager: color_manager,
        map: map
    };
    const clicked_style = config.ClickedParcel;
    const hovered_style = config.HoveredParcel;
    const searched_style = config.SearchedParcel;
    let styles = [new DefaultParcelStyle(clicked_style, hovered_style, searched_style), new ColorizedParcelStyle()];
    let layer;
    if (view === 'inspections')
        layer = new InspectionsLayer(layer_options);
    else if (view === 'salesratioanalysis')
        layer = new SalesRatioLayer(layer_options);
    else
        layer = new ParcelLayer(layer_options);
    layer.style_manager.add_styles(...styles);
    return layer;
};
const gsaLayers = {
    parcel: init_select,
    marker: (parcel_layer) => new MarkerLayer(parcel_layer),
    sketch: new SketchLayer(),
    group: GroupLayer,
    measure: MeasureLayer,
    zoombox: ZoomboxLayer,
    buffer: (parcel_layer, config) => new BufferLayer(parcel_layer, config),
    location: (parcel_layer, config, map) => new CurrentLocationLayer(parcel_layer, config, map)
};
export { gsaLayers as GSALayers };
